import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";

const ITEM_HEIGHT = 48;

export default function LongMenu({ setIsHandlingWarehouse, element, setElementToEdit }) {
  const rowElement = element;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const edit = () => {
    setAnchorEl(null);
    if (setIsHandlingWarehouse !== null) {
      setIsHandlingWarehouse(true);
      setElementToEdit(rowElement);
    }
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <MenuItem key="Editar" onClick={edit}>
          <EditIcon color="success" />
          &nbsp;Editar
        </MenuItem>
        <Divider />
      </Menu>
    </div>
  );
}

LongMenu.defaultProps = {
  setIsHandlingWarehouse: null,
  element: {},
  setElementToEdit: null,
};

LongMenu.propTypes = {
  setIsHandlingWarehouse: PropTypes.any,
  element: PropTypes.object,
  setElementToEdit: PropTypes.func,
};
